import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import * as Plotly from 'plotly.js';
declare global {
  interface Window {
    Plotly: typeof Plotly;
  }
}
@Component({
  selector: 'app-donut-charts',
  templateUrl: './donut-charts.component.html',
  styleUrls: ['./donut-charts.component.css']
})
export class DonutChartsComponent implements OnInit {
  @ViewChild("donut", { static: true }) private donut: ElementRef<HTMLElement>;
  @Input() donutData: any;
  @Input() index: any;
  @Input() paperBgColor: string = '#f6f6f6';
  @Input() plotBgColor: string = '#f6f6f6';
  @Output() donutAction = new EventEmitter<any>();
  private _className: any;
  constructor() { } 

  ngOnInit(): void {
  }

  ngOnChanges() {
    if (this.donutData.length) {
      setTimeout(() => {
        this._plotGraph();
      }, 0);
    }
  }

  private _plotGraph() {
    this._className = 'donut' + JSON.stringify(this.index);
    window.Plotly.newPlot(
      this.donut.nativeElement, //viewchild element
      this.donutData, //data provided
      {
        margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0
        },
        //title: '', //Title of the graph this.donutData[0].title
        hovermode: false,
        // automargin: this.donutData[0].automargin,
        showlegend: this.donutData[0].legend,
        // paper_bgcolor: 'white',
        // plot_bgcolor: 'white',
        paper_bgcolor: this.donutData[0].barColor ? this.donutData[0].barColor : '#f6f6f6',
        plot_bgcolor: this.donutData[0].barColor ? this.donutData[0].barColor : '#f6f6f6',
        legend: {
          orientation: this.donutData[0].orientation ? this.donutData[0].orientation : 'h'
        },
        annotations: this.donutData[0].annotations
      },
      { //this is where the configuration is defined
        responsive: true,
        displaylogo: false,
        scrollZoom: true,
        displayModeBar: false,
        // useResizeHandler: true
      });
    (document.getElementsByClassName(this._className)[this._className] as any).on('plotly_click', (data: any) => {
      this.donutAction.emit(data);
    });
    window.dispatchEvent(new Event('resize'));
  } 
}
